/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const lineLengths = [
    '94%',
    '96%',
    '93%',
    '96%',
    '93%',
    '97%',
    '94%',
    '96%',
    '98%',
    '97%',
    '94%',
];

export default function PlaceholderText({
    fontSize = 14,
    lineHeight = 23.8,
    lines = 1,
    width,
    alignX = 'left',
}) {
    const height = fontSize * 0.857;
    const margin = Math.floor(lineHeight) - height;
    const linesArray = Array.from(Array(lines).keys());

    return (
        <div
            data-component="PlaceholderText"
            className={cx({
                'align-center': alignX === 'center',
                'align-right': alignX === 'right',
            })}
        >
            {linesArray.map((index) => {
                let lineLength = width || lineLengths[index] || '97%';

                if (!width && index === lines - 1) {
                    lineLength = '70%';
                }

                return (
                    <div
                        key={index}
                        style={{
                            paddingTop: `${margin / 2}px`,
                            paddingBottom: `${margin / 2}px`,
                            width: lineLength,
                        }}
                    >
                        <div data-component="Placeholder" style={{ height }} />
                    </div>
                );
            })}
        </div>
    );
}

PlaceholderText.propTypes = {
    /** Text size to simulate (in pixels) */
    fontSize: PropTypes.number,

    /** Line height to simulate (in pixels) */
    lineHeight: PropTypes.number,

    /** Number of lines of text to render */
    lines: PropTypes.number,

    /** Css value - sets the width of all lines to the specified value */
    width: PropTypes.string,

    /** Horizontal alignment of the placeholder within its container */
    alignX: PropTypes.oneOf(['left', 'center', 'right']),
};
